import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {UserService} from './user.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class LicenseService {

  getAll(customerId: string): Observable<Array<License>> {
    return this.http.get('/api/licenses/' + customerId, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => {
        return res.json().data.map((obj: License) => License.fromJSON(obj));
      })
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  findByCustomerIdAndNameAndId(customerId: string, name: string, id: string): Observable<License> {
    return this.http.get('/api/licenses/customer/' + customerId + '/name/' + name + '/id/' + id,
      {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => License.fromJSON(res.json()))
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  verifyExists(customerId: string, name: string, id: string): Observable<boolean> {
    return this.http.get('/api/licenses/check/customer/' + customerId + '/name/' + name + '/id/' + id,
      {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().id ? true : false)
      .catch((error: any) => {
        if (error.status === 404 && error.json().message === 'LICENSE_NOT_FOUND') {
          return Observable.of(false);
        }
        console.log(`Received error:${JSON.stringify(error)}`);
        return Observable.throw(error.json().message || 'Server error');
      });
  };

  save(l: License): Observable<License> {
    return this.http.post('/api/licenses', l, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => License.fromJSON(res.json()))
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  }

  constructor(private http: Http, private us: UserService) {
  }


}

export class License {

  static fromJSON(json: any): License {
    const object = Object.create(License.prototype);
    Object.assign(object, json);
    return object;
  }

  getLicenseState(): LicenseState {
    return LicenseState[this.licenseState];
  }

  setLicenseState(ls: LicenseState) {
    this.licenseState = LicenseState[ls];
  }

  constructor(public name: string, public customerId: string, public id: string, public expiration: number,
              public value: Object, private licenseState: string) {
  }
}

export enum LicenseState {
  VALID,
  DISABLED
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/license.service.ts